import { styled } from '@mui/material';

const FullscreenButtonStyled = styled('button')<{
  isFullscreen: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 30px;
  height: 30px;
  z-index: 3;
  border-radius: 50%;
  top: ${({ isFullscreen }) => (!isFullscreen ? '48px' : '100px')};
  right: ${({ isFullscreen }) => (!isFullscreen ? '-33px' : '18px')};
  background-color: var(--color-secondary);

  cursor: pointer;

  svg,
  i {
    color: #fff;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  &:hover {
    svg,
    i {
      color: var(--color-primary);
    }
  }

  @media screen and (max-width: 425px) and (orientation: portrait) {
    top: ${({ isFullscreen }) => (!isFullscreen ? '52px' : '100px')};
    right: ${({ isFullscreen }) => (!isFullscreen ? '-15px' : '18px')};
  }
`;

export default FullscreenButtonStyled;
